import * as React from 'react';

import * as styles from './Header.css';
import { useInView } from '../../../hooks/useInView';

interface IHeaderProps {
  controls: React.ReactNode;
  setIsHeaderControlsVisible: (isVisible: boolean) => void;
}

export const Header = ({ controls, setIsHeaderControlsVisible }: IHeaderProps) => {
  const [controlsRef, isControlsInView] = useInView<HTMLDivElement>({
    threshold: 0.1,
  });

  React.useEffect(() => {
    setIsHeaderControlsVisible(isControlsInView);
  }, [isControlsInView, setIsHeaderControlsVisible]);

  return (
    <div className={styles['header-container']}>
      <div className={styles['header']}>
        <div className={styles['content']}>
          <h1 className={styles['title']}>
            Бесплатно подберём и&nbsp;поможем купить&nbsp;квартиру от&nbsp;застройщика
          </h1>
          <div ref={controlsRef} className={styles['controls']}>
            {controls}
          </div>
        </div>
      </div>
    </div>
  );
};
